import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink, WA_MESSAGES } from "../../data";

const WhatsAppFab = () => (
  <motion.div
    initial={{ y: 90, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ delay: 2, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    className="fixed inset-x-0 bottom-0 z-40 px-4 pb-4 md:hidden"
    style={{ paddingBottom: "max(1rem, env(safe-area-inset-bottom))" }}
  >
    <a
      href={waLink(WA_MESSAGES.general)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobile-whatsapp-fab"
      className="flex items-center justify-center gap-3 rounded-xl bg-[#25D366] py-4 text-sm font-bold uppercase tracking-[0.1em] text-white shadow-[0_12px_40px_rgba(37,211,102,0.35)]"
    >
      <MessageCircle className="h-5 w-5" strokeWidth={2.5} />
      Konsultasi via WhatsApp
    </a>
  </motion.div>
);

export default WhatsAppFab;
